/* eslint consistent-return: 0 */
/*  eslint-disable */
import _ from 'lodash';
import { apiManagerRequest } from '../../../axios';
import axios from 'axios';
import {
  OBTENER_SANATORIO_SUCCESS,
  OBTENER_SANATORIO_ERROR,
  OBTENER_DIRECCIONES_SUCCESS,
  OBTENER_DIRECCIONES_ERROR,
  LOCALSTORAGE_AUTH_KEY,
  VALIDAR_AFILIADO_SUCCESS,
  VALIDAR_AFILIADO_ERROR,
  VALIDAR_AFILIADO_INMEDIATA_SUCCESS,
  VALIDAR_AFILIADO_INMEDIATA_ERROR,
  GUARDAR_DATOS_SUCCESS,
  GUARDAR_DATOS_CENSOS_SUCCESS,
  GUARDAR_DATOS_CENSOS_ERROR,
  GUARDAR_DATOS_ERROR,
  GUARDAR_DATOS_INMEDIATA_SUCCESS,
  GUARDAR_DATOS_INMEDIATA_ERROR,
  OBTENER_CODIGO_DIAGNOSTICO_SUCCESS,
  OBTENER_CODIGO_DIAGNOSTICO_ERROR,
  OBTENER_PRESTACIONES_SUCCESS,
  OBTENER_PRESTACIONES_ERROR,
  VALIDAR_DIRECCION_ERROR,
  VALIDAR_DIRECCION_SUCCESS,
  VALIDAR_COBERTURA_ERROR,
  VALIDAR_COBERTURA_SUCCESS,
  VALIDAR_DIRECCION_INMEDIATA_SUCCESS,
  VALIDAR_DIRECCION_INMEDIATA_ERROR,
  ES_AUTORIZABLE_SUCCESS,
  ES_AUTORIZABLE_ERROR,
  RESET_ES_AUTORIZABLE_SUCCESS,
  RESET_ES_AUTORIZABLE_ERROR,
  GUARDAR_DATOS_ALTA_SUCCESS,
  GUARDAR_DATOS_ALTA_ERROR,
} from '../../../constants/index';
import { responseWait, responseEnd } from '../../common/loadingActions';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import { Field, reduxForm, formValueSelector, change, reset } from 'redux-form';
import { STATUS_CODE, replaceAccents } from '../../../utils/utils';
import {
  urlTramitesDeAutorizacionesValidarAfiliado,
  urlTramitesDeAutorizacionesTrasladosProgramados,
  urlProvidersBase,
  urlTramitesDeAutorizacionesPrestaciones,
  urlTramitesDeAutorizacionesValidarCobertura,
  urlTramitesDeAutorizacionesSinMateriales,
  urlTramitesDeAutorizacionesConMateriales,
  urlTramitesDeAutorizacionesEsAutorizable,
  urlTramitesDeAutorizacionesDiagnosticoPorDescripcion,
  urlTramitesDeAutorizacionesInmediata,
  urlTramitesDeAutorizacionesOdontodologia,
  urlTramitesDeAutorizacionesSinAutorizacion,
  urlTramitesDeAutorizacionesSolicitudWeb,
  urlTramitesDeAutorizacionesObtenerTerminales,
  urlTramitesDeAutorizacionesDiagnosticoPorCodigo,
  urlValidarAfiliado1,
  urlIngresaPrestacion,
  urlReimpresionTicket,
  urlProvidersBaseV1_1,
  urlTramitesDeAutorizacionesMedicacionUnica,
  urlListPrestacion,
  urlBenefits,
  urlIngresaPrestacionClon,
} from '../../urls';
import { selectAfiliadoAutorizacion } from '../../capweb/capwebActions';
import { logoutUser } from '../../users/logoutUser';
import Session from '../../../utils/session';
import AffiliateService from '../../../services/affiliate';
import ERRORS from '../../../utils/errors';
import SurveyAuthorizationService from '../../../services/Qualtrics/Authorization';
import Dates from '../../../utils/dates';
import AuthorizationService from '../../../services/Authorization';
import { TRANSACTION_TYPES } from '../../../constants/authorization';
import { DataAuthorizationForm } from '../../../documentation/Authorization';

export const obtenerSanatorioSuccess = (data) => ({
  type: OBTENER_SANATORIO_SUCCESS,
  data,
});

export const guardarDatosCensosSuccess = (data) => ({
  type: GUARDAR_DATOS_CENSOS_SUCCESS,
  data,
});

export const guardarDatosCensosError = (data) => ({
  type: GUARDAR_DATOS_CENSOS_ERROR,
  data,
});

export const obtenerSanatorioError = (data) => ({
  type: OBTENER_SANATORIO_ERROR,
  data,
});

export const validarCoberturaSuccess = (data) => ({
  type: VALIDAR_COBERTURA_SUCCESS,
  data,
});

export const validarCoberturaError = (data) => ({
  type: VALIDAR_COBERTURA_ERROR,
  data,
});

export const obtenerDireccionesSuccess = (data) => ({
  type: OBTENER_DIRECCIONES_SUCCESS,
  data,
});

export const obtenerDireccionesSuccessCensos = (data) => ({
  type: GUARDAR_DATOS_ALTA_SUCCESS,
  data,
});

export const obtenerDireccionesError = (data) => ({
  type: OBTENER_DIRECCIONES_ERROR,
  data,
});

export const validarDireccionSuccess = (data) => ({
  type: VALIDAR_DIRECCION_SUCCESS,
  data,
});

export const validarDireccionError = (data) => ({
  type: VALIDAR_DIRECCION_ERROR,
  data,
});

export const validarDireccionInmediataSuccess = (data) => ({
  type: VALIDAR_DIRECCION_INMEDIATA_SUCCESS,
  data,
});

export const validarDireccionInmediataError = (data) => ({
  type: VALIDAR_DIRECCION_INMEDIATA_ERROR,
  data,
});

export const validarAfiliadoSucess = (data) => ({
  type: VALIDAR_AFILIADO_SUCCESS,
  data,
});

export const validarAfiliadoError = (data) => ({
  type: VALIDAR_AFILIADO_ERROR,
  data,
});

export const validarAfiliadoInmediataSucess = (data) => ({
  type: VALIDAR_AFILIADO_INMEDIATA_SUCCESS,
  data,
});

export const validarAfiliadoInmediataError = (data) => ({
  type: VALIDAR_AFILIADO_INMEDIATA_ERROR,
  data,
});

export const guardarDatosSuccess = (data) => ({
  type: GUARDAR_DATOS_SUCCESS,
  data,
});
export const guardarDatosResetSuccess = (data) => ({
  type: GUARDAR_DATOS_SUCCESS,
  data: undefined,
});
export const guardarDatosError = (data) => ({
  type: GUARDAR_DATOS_ERROR,
  data,
});

export const guardarDatosAltaSuccess = (data) => ({
  type: GUARDAR_DATOS_ALTA_SUCCESS,
  data,
});

export const guardarDatosAltaError = (data) => ({
  type: GUARDAR_DATOS_ALTA_ERROR,
  data,
});

export const guardarDatosInmediataResetSuccess = (data) => ({
  type: GUARDAR_DATOS_INMEDIATA_SUCCESS,
  data: undefined,
});

export const guardarDatosInmediataSuccess = (data) => ({
  type: GUARDAR_DATOS_INMEDIATA_SUCCESS,
  data,
});

export const guardarDatosInmediataError = (data) => ({
  type: GUARDAR_DATOS_INMEDIATA_ERROR,
  data,
});

export const obtenerCodigoDiagnosticoSuccess = (data) => ({
  type: OBTENER_CODIGO_DIAGNOSTICO_SUCCESS,
  data,
});

export const obtenerCodigoDiagnosticoError = (data) => ({
  type: OBTENER_CODIGO_DIAGNOSTICO_ERROR,
  data,
});

export const obtenerPrestacionSuccess = (data) => ({
  type: OBTENER_PRESTACIONES_SUCCESS,
  data,
});

export const obtenerPrestacionError = (data) => ({
  type: OBTENER_PRESTACIONES_ERROR,
  data,
});

export const esAutorizableSuccess = (data) => ({
  type: ES_AUTORIZABLE_SUCCESS,
  data,
});

export const esAutorizableError = (data) => ({
  type: ES_AUTORIZABLE_ERROR,
  data,
});

export const resetEsAutorizableSuccess = (data) => ({
  type: RESET_ES_AUTORIZABLE_SUCCESS,
  data,
});

export const resetEsAutorizableError = (data) => ({
  type: RESET_ES_AUTORIZABLE_ERROR,
  data,
});

export const autorizable = (nomenclador, codigo) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }
  const json = {
    token,
    nomenclador,
    codigo,
  };

  const url = `${urlTramitesDeAutorizacionesEsAutorizable}?prestac=${codigo}&nomen=${nomenclador}`;

  try {
    const responseData = await apiManagerRequest.get(url, json);
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      dispatch(esAutorizableSuccess(responseData?.data));
      dispatch(responseEnd());
    } else {
      dispatch(esAutorizableError(''));
      dispatch(responseEnd());
    }
  } catch (error) {
    dispatch(esAutorizableError(''));
    dispatch(responseEnd());
  }
};

export const obtenerSanatorio = () => (dispatch) => {
  // debugger;

  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }

  const json = {
    apeRazonSocial: auth.apeRazonSocial, // Hospital Italiano
    codPrestador: auth.codPrestador, // 1130
  };
  dispatch(obtenerSanatorioSuccess(json));
};

/* Obtener Lugares de atencion  */

export const obtenerDirecciones = (datos) => async (dispatch) => {
  // debugger;
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }
  const json = {
    token,
    codigoPrestador: auth.id,
    datos,
  };

  const fecha = Dates.get().toFormat('YYYYMMDD');

  const url = `${urlProvidersBase}/${json?.codigoPrestador}/lugaresDeAtencion?fecha=${fecha}`;

  try {
    const responseData = await apiManagerRequest.get(url, json);
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      dispatch(obtenerDireccionesSuccess(responseData?.data));
      dispatch(responseEnd());
    } else {
      dispatch(obtenerDireccionesError(''));
      dispatch(responseEnd());
    }
  } catch {
    dispatch(obtenerDireccionesError(''));
    dispatch(responseEnd());
  }
};

export const obtenerDireccionesInmediatas = () => async (dispatch) => {
  // debugger;
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }
  const json = {
    token,
    codigoPrestador: auth.id,
  };

  const fecha = Dates.get().toFormat('YYYYMMDD');

  const url = `${urlProvidersBase}/${json?.codigoPrestador}/lugaresDeAtencion?fecha=${fecha}`;

  try {
    const responseData = await apiManagerRequest.get(url, json);
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      dispatch(obtenerDireccionesSuccess(responseData?.data));
      dispatch(responseEnd());
    } else {
      dispatch(obtenerDireccionesError(''));
      dispatch(responseEnd());
    }
  } catch {
    dispatch(obtenerDireccionesError(''));
    dispatch(responseEnd());
  }
};

export const obtenerTerminalesInmediataPacientesRegistrados = (code) => async (dispatch) => {
  dispatch(responseWait());
  const codPrestador = code ?? Session.getAuth()?.modelEspecifico.codPrestador;

  const url = `${urlProvidersBase}/${codPrestador}/terminales?codigoEmpresaConectividad=9`;

  try {
    const responseData = await apiManagerRequest.get(url);

    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      dispatch(obtenerDireccionesSuccess(responseData?.data));
      dispatch(responseEnd());
    } else {
      dispatch(obtenerDireccionesError(''));
      dispatch(responseEnd());
    }
  } catch {
    dispatch(obtenerDireccionesError(''));
    dispatch(responseEnd());
  }
};

/* Validar Direcciones */

export const validarDireccion = (plan, direccion, tipo) => async (dispatch) => {
  // debugger;
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }
  const json = {
    token,
    codigoPrestador: auth.id,
    plan,
    direccion,
  };

  const url = `${urlProvidersBase}/${json?.codigoPrestador}/lugaresDeAtencion/${direccion}/validarCartillaAfiliado?codigoCartilla=${plan}`;

  try {
    const responseData = await apiManagerRequest.get(url, json);
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      if (tipo == 0) {
        dispatch(validarDireccionSuccess(responseData?.data));
      } else {
        dispatch(validarDireccionInmediataSuccess(responseData?.data));
      }
    } else {
      if (tipo == 0) {
        dispatch(validarDireccionError(''));
      } else {
        dispatch(validarDireccionInmediataError(''));
      }
    }
  } catch {
    if (tipo == 0) {
      dispatch(validarDireccionError(''));
    } else {
      dispatch(validarDireccionInmediataError(''));
    }
  } finally {
    dispatch(responseEnd());
  }
};

/* Validar Cobertura */

export const validarCobertura = (prestacion, plan, contra, inte, prepaga) => (dispatch) => {
  // debugger;
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;
  let prestador;

  if (auth) {
    token = Session.getAuthenticationToken();
    prestador = auth.id;
  }

  /*   this.token = req.body.token; */
  /*  this.prestador = req.body.codigoPrestador;
   */
  const options = (url) => {
    return {
      url,
      method: 'GET',
      headers: {
        /*         'Content-Type': 'application/json',
                Accept: 'application/json',
                'Cache-Control': 'no-cache', */
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const getCobertura = async (options, body) => {
    const { prepaga, contra, plan, inte, codigoPrestador, prestacion } = body;
    const { nomenclador, codigo } = prestacion;
    let fecha = new Date();
    fecha = Dates.get(fecha).toFormat('YYYYMMDD');
    let response;
    const url = `${urlTramitesDeAutorizacionesValidarCobertura}?prepagaAfilmed=${prepaga}&codigoPlan=${plan}&fecha=${fecha}&nomenclador=${nomenclador}&prestacion=${codigo}&contratoAfilmed=${contra}&integranteAfilmed=${inte}&prestador=${codigoPrestador}`;

    await axios(options(url))
      .then((res) => {
        response = res.data;
      })
      .catch((err) => {
        throw err;
      });
    dispatch(responseEnd());

    return response;
  };

  const getTerminales = async (options, prestador) => {
    dispatch(responseWait());
    let response;
    const url = `${urlProvidersBase}/${prestador}/terminales?codigoEmpresaConectividad=9`;
    await axios(options(url))
      .then((res) => {
        response = res.data;
      })
      .catch((err) => {
        throw err;
      });
    dispatch(responseEnd());

    return response;
  };

  const getCirculos = async (options, prestador) => {
    dispatch(responseWait());

    const auth = Session.getAuth();
    let token;

    if (auth) {
      token = Session.getAuthenticationToken();
    }
    let response;
    //const prestador2 = 45777;
    const nTerminal = prestador ? prestador : auth?.id;

    const url = `${urlProvidersBaseV1_1}/${nTerminal}/circulos`;
    await axios(options(url))
      .then((res) => {
        response = res.data;
      })
      .catch((err) => {
        if (err.response.status === 404) {
          response = {};
        } else {
          throw err;
        }
      });
    dispatch(responseEnd());
    return await response;
  };

  const validarCobertura = async () => {
    try {
      let result = {};
      let body = {
        prepaga,
        contra,
        plan,
        inte,
        prestacion,
        codigoPrestador: prestador,
      };
      // Primero obtengo la cobertura del prestador;
      const cobertura = await getCobertura(options, body);

      const { mod_cobert, exceptuada } = cobertura;
      //Guardo el Resultado
      result = { mod_cobert, exceptuada, terminales: false };

      if (mod_cobert === 'AP' && !exceptuada) {
        //Busco si tiene terminales
        const terminales = await getTerminales(options, prestador);
        //Busco si tiene circulos
        const circulo = await getCirculos(options, prestador);
        // Validacion
        if (!_.isEmpty(terminales)) {
          result.terminales = terminales;
        }
        if (!_.isEmpty(circulo)) {
          result.circulo = circulo;
          // result.circulo[0].posee_term_swiss_circulo = true;
          if (_.find(circulo, { posee_term_swiss_circulo: 1 })) {
            result.origenDeTransaccion = true;
          } else {
            result.origenDeTransaccion = false;
          }
        } else {
          result.circulo = false;
        }
      }

      const { terminales, origenDeTransaccion } = result;
      if (!_.isEmpty(terminales) && !origenDeTransaccion) {
        dispatch(obtenerDireccionesSuccess(terminales));
        dispatch(responseEnd());

        result.mostrar = true;
      }

      dispatch(validarCoberturaSuccess(result));
      dispatch(responseEnd());

      return result;
    } catch (e) {
      console.error(e);
    }
  };
  /*   export const validarCoberturaSuccess = data => ({
      type: VALIDAR_COBERTURA_SUCCESS,
      data,
    });

    export const validarCoberturaError = data => ({
      type: VALIDAR_COBERTURA_ERROR,
      data,
    });
   */
  // Ejecuto la funcion

  validarCobertura();
};

/* Validar Cobertura */

export const obtenerTerminales = (codigo) => async (dispatch) => {
  // debugger;
  dispatch(responseWait());
  const auth = Session.getAuth();

  try {
    dispatch(responseEnd());
    const { status, data } = await apiManagerRequest.post(
      urlTramitesDeAutorizacionesObtenerTerminales,
      { codigoPrestador: auth.id, codigo },
    );

    if (status === 200) {
      dispatch(obtenerDireccionesSuccess(data));
    }
  } catch (error) {
    dispatch(obtenerDireccionesError(''));
  }
};

export const resetInput = (field, value) => (dispatch) => {
  dispatch(change('AltaDeTramiteForm', field, value));
};

export const resetForm = (formName) => (dispatch) => {
  dispatch(reset(formName));
};

export const validarAfiliado =
  async (contra, inte, validador, tipoConectividad) => async (dispatch) => {
    dispatch(responseWait());
    try {
      const response = await AffiliateService.validate(contra, inte, validador, false);
      dispatch(validarAfiliadoInmediataSucess(response));
      dispatch(validarAfiliadoSucess(response, tipoConectividad));
    } catch (error) {
      dispatch(validarAfiliadoError('', tipoConectividad));
    } finally {
      dispatch(responseEnd());
    }
  };

export const validarAfiliadoC =
  (contra, inte, tipo, onSelectHandler, tipoConectividad) => async (dispatch) => {
    dispatch(responseWait());

    try {
      const response = await AffiliateService.validateSimple(contra, inte);

      if (tipo == 1) {
        dispatch(validarAfiliadoInmediataSucess(response));
        onSelectHandler?.(response);
        return;
      }

      dispatch(validarAfiliadoSucess(response));
      onSelectHandler?.(response);
    } catch (error) {
      dispatch(validarAfiliadoError('', tipoConectividad));
    } finally {
      dispatch(responseEnd());
    }
  };

export const guardarTramiteInmediato = (datos) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;
  let cuitSwiss;

  if (auth) {
    token = Session.getAuthenticationToken();
    cuitSwiss = auth.cuit.trim();
  }

  const url = `${urlTramitesDeAutorizacionesInmediata}`;
  const prestador = auth.id;
  const numeroDeAfiliado = datos.numeroDeAfiliado.split(' ');
  const contra = numeroDeAfiliado[0];
  const inte = numeroDeAfiliado[2];

  const imagenes = [];
  if (!_.isEmpty(datos.archivos)) {
    datos.archivos.map((img) => {
      const image = {};
      image.fileName = `${img.name ? img.name.replace(/[\W_\r\n]+/g, ' ') : '_'}.${img.extension}`;
      image.sizeInBytes = `${img.size}`;
      image.base64Content = img.base64;
      imagenes.push(image);
    });
  }

  let today = new Date();
  let dd = String(today.getDate()).padStart(2, '0');
  let mm = String(today.getMonth() + 1).padStart(2, '0');
  let yyyy = today.getFullYear();
  today = yyyy + mm + dd;

  const fechaDeInter = datos.fechaDeInternacion.split('/');
  const fecha = fechaDeInter[2] + fechaDeInter[1] + fechaDeInter[0];

  let isCircle;

  if (datos.circulo == true) {
    isCircle == datos.circulo;
  }

  datos.codPrestador = auth.codPrestador
    ? auth.codPrestador
    : auth.codigoPrestador
    ? auth.codigoPrestador
    : '';

  // SI envio circulo false, agarro el cuit del logueado
  datos.cuit = !datos.circulo ? auth.cuit : datos.cuit;

  const moreSixtyDays = new Date();
  moreSixtyDays.setDate(moreSixtyDays.getDate() + 60);
  const formatDate = (date) => {
    let mes = parseInt(date.getMonth() + 1, 10);
    if (mes < 10) {
      mes = `0${mes}`;
    }
    let dia = parseInt(date.getDate(), 10);
    if (dia < 10) {
      dia = `0${dia}`;
    }
    return `${dia}/${mes}/${date.getFullYear()}`;
  };

  const observacion =
    datos.observacion && datos.observacion !== ''
      ? reemplazarAcentos(datos.observacion).replace(/[\W_\r\n]+/g, ' ')
      : '';

  const json = {
    prestador,
    lugarAtencionPrestador: parseInt(datos.direccion, 10),
    autorizacion: {
      observacion,
      fechaOrden: datos.fechaDeOrden,
      fechaInternacion: datos.fechaDeInternacion,
      fechaValidezOrden: formatDate(moreSixtyDays),
      sala: {
        id: parseInt(datos.sector, 10),
      },
      diasInternacion: parseInt(datos.diasInternacion) || 1,
      tipoInternacion: {
        id: datos.tipoInternacion,
      },
      diagnostico: {
        icd: datos.diagnostico.id,
        descripcion: datos.diagnostico.descripcion,
      },
      efector: {
        apellidoRazonSocial: replaceAccents(datos.nombreApellido),
        matricula: {
          numero: datos.nroMatricula.toString(),
          tipo: datos.tipoMatricula,
        },
      },
    },
    afiliado: {
      plan: {
        codigo: datos.planCodi,
      },
      contra,
      inte,
      prepaga: 0,
    },
    imagenes,
  };
  try {
    const responseData = await apiManagerRequest.post(url, json);

    const datos2 = {
      ackacept: null,
      ackackapl: null,
      agRecha: null,
      agRechaCabe: null,
      alta: today,
      circulo: datos.circulo ? datos.circulo : false,
      codPrestador: '',
      consulta: 'N',
      creden: datos.numeroDeAfiliado.replace(/\s/g, ''),
      cuit: datos.cuit,
      fecdif: fecha,
      icd: null,
      idPrescr: null,
      interNro: null,
      manual: '0',
      modo: 'N',
      msgId: null,
      oriMatri: 'P',
      param1: '1^*43422003*1**',
      param2: null,
      param3: null,
      powerBuilder: 0,
      rechaExt: 0,
      termId: datos.termId,
      ticketExt: 0,
      tipo: 90,
      tipoEfector: datos.circulo ? 'CUIT' : null, //palabra CUIT
      idEfector: datos.circulo ? auth.cuit.trim() : null, //cuit del logueado
      tipoMensaje: null,
      tipoPrescr: '',
    };

    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      if (cuitSwiss === '30654855168') {
        dispatch(guardarDatosInmediataSuccess(responseData?.data));
      } else if (cuitSwiss !== '30654855168') {
        dispatch(guardarDatosInmediataSuccess(responseData?.data));
        dispatch(guardarDatosCensos(datos2));
      }
    } else {
      dispatch(guardarDatosInmediataError(''));
    }
  } catch {
    dispatch(guardarDatosInmediataError(''));
  } finally {
    dispatch(responseEnd());
  }
};

export const guardarDatosCensos = (datos) => async (dispatch) => {
  const tipo = 'ingresarPrestacion';
  const auth = Session.getAuth();

  datos.codPrestador = auth.codPrestador ? auth.codPrestador : auth.id ? auth.id : '';
  if (tipo === 'ingresarPrestacion' || tipo === 'elegibilidad') {
    // SI envio circulo false, agarro el cuit del logueado
    datos.cuit = !datos.circulo ? auth.cuit : datos.cuit;
    if (tipo === 'elegibilidad' && !datos.circulo) {
      const apellido = auth.apellidoPrestador
        ? auth.apellidoPrestador + ', '
        : auth.tipoPersona && auth.tipoPersona.apellido
        ? auth.tipoPersona.apellido + ', '
        : '';
      const nombre = auth.nombreAbre
        ? auth.nombreAbre
        : auth.tipoPersona && auth.tipoPersona.nombre
        ? auth.tipoPersona.nombre
        : '';
      datos.nomPrestador = apellido + nombre;
    }
  } else if (tipo === 'anularPrestacion' || tipo === 'ingresarDiagnostico') {
    if (datos.cuitEfector === auth.cuit && datos.cuitPrestador !== auth.cuit) {
      datos.cuit = datos.cuitPrestador;
    } else {
      datos.cuit = auth.cuit;
    }
  } else if (tipo === 'anularDiagnostico') {
    datos.cuit = datos.cuitPrestador ? datos.cuitPrestador : auth.cuit;
  } else {
    datos.cuit = auth.cuit;
  }

  let json = datos;
  let url = '';
  // Guardo codPrestador para enviarlo despues
  const codPrestador = datos.codPrestador;

  const formatData = (resp, type) => {
    if (type === 'reimpresionTicket') {
      if (Array.isArray(resp)) {
        resp = resp[0];
      }
      resp.comprobante.tipoConectividad = type;
      resp.comprobante.cuit = datos.cuit;
      resp.comprobante.termId = datos.terminal;
      resp.comprobante.creden = datos.credencial;
      resp.comprobante.codPrestador = codPrestador;
    } else {
      resp.tipoConectividad = type;
      resp.cuit = datos.cuit;
      resp.termId = datos.termId;
      resp.creden = datos.creden;
      resp.codPrestador = codPrestador;
      resp.apeNom = datos.apeNom;
      resp.gravado = datos.gravado;
      if (type === 'elegibilidad') resp.nomPrestador = datos.nomPrestador;
    }
    return resp;
  };

  if (tipo === 'ingresarPrestacion') {
    url = `${urlIngresaPrestacionClon}/${codPrestador}/ingresa-prestacion`;
    json = {
      modo: datos.modo,
      tipo: datos.tipo,
      alta: datos.alta,
      fecdif: datos.fecdif,
      manual: datos.manual,
      ticketExt: datos.ticketExt,
      interNro: datos.interNro,
      oriMatri: datos.oriMatri,
      autoriz: datos.autoriz,
      icd: datos.icd,
      rechaExt: datos.rechaExt,
      param1: datos.param1,
      param2: datos.param2,
      param3: datos.param3,
      tipoEfector: datos.tipoEfector,
      idEfector: datos.idEfector,
      tipoPrescr: datos.tipoPrescr,
      idPrescr: datos.idPrescr,
      msgId: datos.msgId,
      ackacept: datos.ackacept,
      ackackapl: datos.ackackapl,
      consulta: datos.consulta,
      agRechaCabe: datos.agRechaCabe,
      agRecha: datos.agRecha,
      tipoMensaje: datos.tipoMensaje,
      powerBuilder: datos.powerBuilder,
      cuit: datos.cuit,
      termId: datos.termId,
      creden: datos.creden,
    };
  }

  try {
    let resp;

    if (tipo === 'reimpresionTicket') {
      resp = await apiManagerRequest.get(`${urlReimpresionTicket}/${datos.ticket}`, json);
    } else {
      resp = await apiManagerRequest.post(url, json);
    }

    if (resp.status === 200) {
      const data = formatData(resp.data, tipo);
      dispatch(guardarDatosCensosSuccess(data, tipo));
    }

    if (resp.status === 401) {
      return dispatch(logoutUser());
    }
  } catch (error) {
    dispatch(guardarDatosError('', tipo));
  } finally {
    dispatch(responseEnd());
  }
};

export const obtenerDiagnosticoPorCodigo = (codigo) => async (dispatch) => {
  try {
    const { status, data } = await apiManagerRequest.post(
      urlTramitesDeAutorizacionesDiagnosticoPorCodigo,
      { codigo },
    );

    if (status === 200) {
      dispatch(obtenerCodigoDiagnosticoSuccess(data));
    }
  } catch (error) {
    dispatch(obtenerCodigoDiagnosticoError(''));
  }
};

export const obtenerDiagnosticoPorDescripcion = (descripcion) => async (dispatch) => {
  const auth = Session.getAuth();
  let token;

  if (auth) {
    token = Session.getAuthenticationToken();
  }

  const json = {
    token,
    descripcion,
  };

  const url = `${urlTramitesDeAutorizacionesDiagnosticoPorDescripcion}?denominacion=%25${descripcion}%25&visible-auto=true`;

  try {
    const responseData = await apiManagerRequest.get(url, json);

    if (responseData?.status == 200) {
      dispatch(obtenerCodigoDiagnosticoSuccess(responseData?.data));
    } else {
      dispatch(obtenerCodigoDiagnosticoError(''));
    }
  } catch {
    dispatch(obtenerCodigoDiagnosticoError(''));
  }
};

export const getBenefits = (code, description) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth();
  let token;
  let url;

  if (auth) {
    token = Session.getAuthenticationToken();
  }

  let json = {
    token,
  };

  if (code) {
    json = {
      ...json,
      codigo: code,
    };

    url = `${urlTramitesDeAutorizacionesPrestaciones}${code}`;
  }

  if (description) {
    json = {
      ...json,
      descripcion: description,
    };

    url = `${urlBenefits}?tipo=medicas&activa=true&descripcion=${description}`;
  }

  try {
    const { status, data } = await apiManagerRequest.get(url, json);

    if (status != 200) {
      throw new Error();
    }

    dispatch(obtenerPrestacionSuccess(data));
  } catch (error) {
    dispatch(obtenerPrestacionError(''));
  } finally {
    dispatch(responseEnd());
  }
};

export const getListAgreedBenefits =
  (plan, codeProvider, address, code, description, date) => async (dispatch) => {
    dispatch(responseWait());
    const dateFormated = date ? Dates.get(date, 'DD/MM/YYYY').toFormat('YYYYMMDD') : '';

    const url = `${urlListPrestacion}?prestadCodigo=${codeProvider}&fecha=${
      dateFormated ?? ''
    }&prestacDesc=${description ?? ''}&plan=${plan?.trim() ?? ''}&prestacCodigo=${
      code ?? ''
    }&prestadLugar=${address}`;

    try {
      const { status, data } = await apiManagerRequest.get(url);

      if (status != 200) {
        throw new Error();
      }

      dispatch(obtenerPrestacionSuccess(data));
    } catch (error) {
      dispatch(obtenerPrestacionError(''));
    } finally {
      dispatch(responseEnd());
    }
  };

//* ALTA DE TRAMITES CONECTIVIDAD */

export const saveConnectivity = (datos, circulo, terminales) => async (dispatch) => {
  dispatch(responseWait());
  const auth = Session.getAuth();
  const cuitPrestador = auth.cuit;
  const prestador = auth.id;

  const fecha = Dates.get().toFormat('YYYYMMDD');

  const {
    circuloAsociaciones,
    credencial,
    origenDeTransaccion,
    direccion,
    direccion2,
    fechaDePrestacion,
    prestacion,
    efector,
    prescriptor,
    tipoDeMatricula,
    nroMatricula,
    provincia,
    tipoDeMatriculaEfector,
    nroMatriculaEfector,
    provinciaEfector,
    tokenAfiliado,
  } = datos;

  const numeroDeAfiliado = datos.numeroDeAfiliado;
  const reqToken = tokenAfiliado ? '|' + tokenAfiliado : '';

  const param1 = `1^*${prestacion.codigo}*1**`;
  const provinciaVal = provincia ? provincia : '';
  const provinciaEfectorVal = provinciaEfector ? provinciaEfector : '';

  let cuit = '';
  let creden = `${numeroDeAfiliado.replace(/ /g, '')}${credencial}${reqToken}`;

  if (
    origenDeTransaccion === 'circuloMedico' ||
    (_.isEmpty(terminales) && !_.isEmpty(_.find(circulo, { posee_term_swiss_circulo: 1 })))
  ) {
    cuit = _.find(circulo, { prestad_circulo: parseInt(circuloAsociaciones) }).prestad_cuit;
  } else {
    cuit = cuitPrestador;
  }

  let fechaDePrestacionSplit;
  let fechaDePrestacionFormateada;
  if (fechaDePrestacion && fechaDePrestacion !== '') {
    fechaDePrestacionSplit = fechaDePrestacion.split('/');
    fechaDePrestacionFormateada =
      fechaDePrestacionSplit[2] + fechaDePrestacionSplit[1] + fechaDePrestacionSplit[0];
  }
  const json = {
    modo: 'N', //fijo
    tipo: 90,
    alta: fecha,
    fecdif: fechaDePrestacionFormateada, //20181031,
    manual: '0', //fijo
    ticketExt: 0, //Fijo
    interNro: 2, //fijo
    oriMatri: 'P',
    autoriz: null,
    icd: null,
    rechaExt: 0,
    param1,
    param2: null,
    param3: null,
    tipoEfector: efector ? `${tipoDeMatriculaEfector}${efector}${provinciaEfectorVal}` : null,
    idEfector: efector ? nroMatriculaEfector : null,
    tipoPrescr: prescriptor ? `${tipoDeMatricula}${prescriptor}${provinciaVal}` : null,
    idPrescr: prescriptor ? nroMatricula : null,
    msgId: null,
    ackacept: null,
    ackackapl: null,
    consulta: 'N',
    agRechaCabe: null,
    agRecha: null,
    tipoMensaje: null,
    powerBuilder: 0,
    cuit: cuit.trim(),
    termId: direccion2 ? direccion2.trim() : '',
    creden,
  };

  try {
    const responseData = await apiManagerRequest.post(
      `${urlIngresaPrestacionClon}/${prestador}/ingresa-prestacion`,
      json,
    );
    if (responseData?.status === STATUS_CODE.HTTP_200_OK) {
      let epResult = {
        cabecera: responseData?.data.cabecera,
        detalle: responseData?.data.detalle,
        creden: creden,
        prestacion: prestacion,
        terminales: direccion,
        codigoPrestador: prestador,
      };
      SurveyAuthorizationService.saveAuthorizationAction();
      dispatch(guardarDatosSuccess(epResult));
    } else {
      dispatch(guardarDatosAltaError(''));
    }
  } catch ({ response: { data } }) {
    errorSaveTransactionFactory(data, dispatch);
  } finally {
    dispatch(responseEnd());
  }
};

//* ALTA DE TRAMITES */
/**
 * @param {DataAuthorizationForm} data
 */
export const save = (data) => async (dispatch) => {
  dispatch(responseWait());

  const types = {
    [TRANSACTION_TYPES.SCHEDULED_TRANSFER]: AuthorizationService.saveScheduledTransfer,
    [TRANSACTION_TYPES.DENTAL]: AuthorizationService.saveDental,
    [TRANSACTION_TYPES.MEDICAL_AUTHORIZATION]: AuthorizationService.saveMedical,
    // [TRANSACTION_TYPES.DISABILITY]: null
  };

  try {
    if (!types[data?.tipoDeTramite]) {
      throw new Error();
    }

    const dataResponse = await types[data.tipoDeTramite](data);

    dispatch(guardarDatosSuccess(dataResponse));
    SurveyAuthorizationService.saveAuthorizationAction();
    return dataResponse;
  } catch (error) {
    errorSaveTransactionFactory(error, dispatch);
  } finally {
    dispatch(responseEnd());
  }
};

const errorSaveTransactionFactory = (err, dispatch) => {
  const errors = {
    [STATUS_CODE.HTTP_400_BAD_REQUEST]: { status: err.status, message: err.message },
  };

  return dispatch(guardarDatosError(errors[err.status] ?? 'Error'));
};
